import { IResponseState } from "../../../components/Modals/ResponseModal/module/constants";
import {
  LIST_IDENTIFIER,
  LOADER_IDENTIFIER,
  STATE_IDENTIFIER,
} from "./constants";

const { USERS, REQUEST_STATE, SELECTED_USER, PASSWORD_POLICY } =
  STATE_IDENTIFIER;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  [USERS]: {
    [LOADER_IDENTIFIER]: false,
    [LIST_IDENTIFIER]: [],
  },
  [SELECTED_USER]: {},
  [REQUEST_STATE]: IResponseState.PENDING,
  [PASSWORD_POLICY]: {
    lastNpassword: 0,
    allowEmptyPassword: false,
    minLength: 0,
    maxLength: 99999,
    lowerCase: {
      min: 0,
      allowed: false,
    },
    upperCase: {
      min: 0,
      allowed: false,
    },
    numberChar: {
      min: 0,
      allowed: false,
    },
    specialChar: {
      min: 0,
      allowed: false,
      allowedCharList: [],
    },
  },
};
